import {Integer} from '@pb/kit-component-formatters';

import type {Locale} from '@pb/kit-context-locale';

export const getMainColumnHeader = (caption: string, locale: Locale, totalCount?: number) => {
    if (totalCount) {
        return caption + (totalCount ? ` (${Integer.format(totalCount, locale)})` : '');
    }

    return caption;
};
